import { motion } from 'framer-motion';

interface FormHeaderProps {
  showProviders: boolean;
}

const FormHeader = ({ showProviders }: FormHeaderProps) => {
  return (
    <motion.div 
      layout
      transition={{
        layout: { type: "spring", stiffness: 300, damping: 30 }
      }}
      className="text-center pt-8 pb-4"
    >
      <h2 className="text-2xl font-bold text-[#694e42]">
        {!showProviders ? "Connect your email" : "Connect Your Mailbox"}
      </h2>
      {!showProviders && (
        <motion.p 
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="text-[#8a7266] text-sm mt-2"
        >
          Enter your email address to get started with Mailmaid
        </motion.p>
      )}
    </motion.div>
  );
};

export default FormHeader;